import { BaseMapper } from '@ps/utils';

import { NotificationSurveyCommentDto } from '../dtos/notification-survey-comment.dto';
import { NotificationActionLiveState } from '../../state/notification.model';
import { NotificationActionResultMapper } from './notification-action-result.mapper';

export class NotificationSurveyCommentMapper extends BaseMapper<
  NotificationSurveyCommentDto,
  NotificationActionLiveState[]
> {
  private readonly _resultMapper = new NotificationActionResultMapper();

  public fromDto(
    commentDto: NotificationSurveyCommentDto,
  ): NotificationActionLiveState[] {
    return (commentDto.actions ?? []).map((actionDto) => ({
      commentId: `${commentDto.id}`,
      actionId: actionDto.actionId,
      config: actionDto.config ?? {},
      result: this._resultMapper.fromDto(actionDto),
    }));
  }
}
